import React from "react";
import { Facebook, Instagram, Globe, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const services = ["Broom Finished Concrete", "Concrete Patios", "Decorative Concrete", "Stamped Concrete", "Driveways & Repair", "Garage Floors", "Pole Barn Floors", "Retaining Walls", "Walls & Footings", "Basement Floors", "Custom Concrete Projects"];
  const navLinks = [{
    label: "Home",
    to: "/"
  }, {
    label: "About Us",
    to: "#about"
  }, {
    label: "Services",
    to: "#services"
  }, {
    label: "Projects",
    to: "#gallery"
  }, {
    label: "Testimonials",
    to: "#testimonials"
  }, {
    label: "Contact",
    to: "#contact"
  }];
  return <section id="footer" className="dark bg-background text-foreground pt-20 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        
        <div className="flex flex-col lg:flex-row justify-between items-start gap-10 mb-16">
          <div className="max-w-lg">
            <Link to="/" className="block mb-6" newTab>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568171/img/image_7hzhto0j.png" alt="ConcreteCraft Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6">
              ConcreteCraft is a locally owned residential and commercial concrete contractor serving Central and Northern Indiana with nearly 20 years of experience. We deliver high-quality craftsmanship built to last, from driveways to decorative patios.
            </p>
            <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors">
              <Link to="tel:317-709-9540" newTab>call to schedule a quote</Link>
            </Button>
          </div>
        </div>

        <Separator className="bg-border/40 mb-16" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="flex flex-col gap-6">
            <h3 className="text-foreground font-semibold tracking-tight text-lg">Navigation</h3>
            <nav className="flex flex-col gap-3">
              {navLinks.map((link, i) => <Link key={i} data-index={i} to={link.to} className="text-muted-foreground hover:text-primary transition-colors text-sm w-fit flex items-center gap-2" newTab>
                  <span className="h-1 w-1 rounded-full bg-primary/50 opacity-0 transition-opacity group-hover:opacity-100" />
                  {link.label}
                </Link>)}
            </nav>
          </div>

          <div className="flex flex-col gap-6 lg:col-span-2">
            <h3 className="text-foreground font-semibold tracking-tight text-lg">Our Services</h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="#services" className="text-muted-foreground hover:text-primary transition-colors text-sm w-fit block" newTab>
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="text-foreground font-semibold tracking-tight text-lg">Contact Us</h3>
            <div className="flex flex-col gap-5">
              <div className="flex items-start gap-3 text-muted-foreground group">
                <div className="bg-primary/10 p-2 rounded-md shrink-0 group-hover:bg-primary/20 transition-colors">
                  <MapPin className="h-5 w-5 text-primary" />
                </div>
                <span className="text-sm leading-relaxed mt-1 group-hover:text-foreground transition-colors">
                  Central and Northern Indiana
                </span>
              </div>
              
              <div className="flex items-center gap-3 text-muted-foreground group">
                <div className="bg-primary/10 p-2 rounded-md shrink-0 group-hover:bg-primary/20 transition-colors">
                  <Phone className="h-5 w-5 text-primary" />
                </div>
                <Link to="tel:317-709-9540" className="text-sm hover:text-primary transition-colors" newTab>317-709-9540</Link>
              </div>
              
              <div className="flex items-center gap-3 text-muted-foreground group">
                <div className="bg-primary/10 p-2 rounded-md shrink-0 group-hover:bg-primary/20 transition-colors">
                  <Mail className="h-5 w-5 text-primary" />
                </div>
                <Link to="mailto:dscconcreteconstruction@gmail.com" className="text-sm hover:text-primary transition-colors" newTab>
                  dscconcreteconstruction@gmail.com
                </Link>
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-border/40 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-muted-foreground">
          <p className="text-center md:text-left">
            &copy; {currentYear} ConcreteCraft. All rights reserved.
          </p>
          
          <div className="flex items-center gap-4">
            <Link to="https://www.facebook.com/profile.php?id=61580679594074" aria-label="Facebook" className="bg-secondary/10 p-2 rounded-full hover:bg-primary hover:text-primary-foreground transition-all duration-300" newTab>
              <Facebook className="h-4 w-4" />
            </Link>
            <Link to="https://www.instagram.com/dscconcret1688?igsh=MW91cWl6eDQ4YmdkOA" aria-label="Instagram" className="bg-secondary/10 p-2 rounded-full hover:bg-primary hover:text-primary-foreground transition-all duration-300" newTab>
              <Instagram className="h-4 w-4" />
            </Link>
            <Link to="https://share.google/LVU8czGaydm3QsTVL" aria-label="Google" className="bg-secondary/10 p-2 rounded-full hover:bg-primary hover:text-primary-foreground transition-all duration-300" newTab>
              <Globe className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}